import React from 'react';
import { Award } from 'lucide-react';
import ReviewsSection from '@/pages/entity/ReviewsSection';

const EntityMainContent = ({ entity, currentUser, onAggregateChange }) => {
  return (
    <div className="md:col-span-2 space-y-8">
      {/* About */}
      <div className="bg-card rounded-2xl border border-border/50 p-6">
        <h2 className="text-lg font-semibold mb-4">About</h2>
        <p className="text-muted-foreground leading-relaxed">{entity.description}</p>
      </div>

      {/* Specialties (for guides) */}
      {entity.specialties?.length > 0 && (
        <div className="bg-card rounded-2xl border border-border/50 p-6">
          <h2 className="text-lg font-semibold mb-4">Specialties</h2>
          <div className="flex flex-wrap gap-2">
            {entity.specialties.map((specialty) => (
              <span key={specialty} className="tag capitalize">
                {specialty}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Certifications (for guides) */}
      {entity.certifications?.length > 0 && (
        <div className="bg-card rounded-2xl border border-border/50 p-6">
          <h2 className="text-lg font-semibold mb-4">Certifications</h2>
          <div className="space-y-3">
            {entity.certifications.map((cert) => (
              <div key={cert} className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                  <Award className="h-5 w-5 text-primary" />
                </div>
                <span className="font-medium">{cert}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Reviews & Ratings */}
      <ReviewsSection
        entityId={entity.entity_id}
        entityName={entity.name}
        currentUser={currentUser}
        onAggregateChange={onAggregateChange}
      />
    </div>
  );
};

export default EntityMainContent;
